<script setup lang="ts">
import { computed } from 'vue'
import ErrorBoundary from '@/components/ErrorBoundary.vue'
import SentryTestButtons from '@/components/SentryTestButtons.vue'

// Handle errors from error boundary
const handleError = (error: Error, errorInfo: any) => {
  console.error('App-level error:', error, errorInfo)
}

// Check if we're in development mode
const isDevelopment = computed(() => import.meta.env.DEV)
</script>

<template>
  <!-- Wrap the entire app in an error boundary -->
  <ErrorBoundary @error="handleError">
    <!-- router-view is where Vue Router will render the current page component -->
    <router-view />
    
    <!-- Sentry test buttons (only in development) -->
    <SentryTestButtons v-if="isDevelopment" />
  </ErrorBoundary>
</template>
